import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export default function Step3TestsObservations({ formData, updateFormData, errors }) {
  const handleChange = (field, value) => {
    updateFormData({
      ...formData,
      [field]: value,
    });
  };

  const today = new Date().toISOString().split('T')[0];
  const currentTime = new Date().toTimeString().slice(0, 5);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-heading font-bold text-slate-900 mb-2">
          Pruebas y Observaciones
        </h2>
        <p className="text-slate-600">
          Detalles de la solicitud de laboratorio
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="fecha" className="font-medium text-slate-700">
            Fecha <span className="text-red-500">*</span>
          </Label>
          <Input
            id="fecha"
            data-testid="fecha-input"
            type="date"
            value={formData.fecha || today}
            onChange={(e) => handleChange('fecha', e.target.value)}
            className={`h-11 ${errors.fecha ? 'border-red-500' : ''}`}
          />
          {errors.fecha && (
            <p className="text-sm text-red-500">{errors.fecha}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="hora_toma" className="font-medium text-slate-700">
            Hora de la toma <span className="text-red-500">*</span>
          </Label>
          <Input
            id="hora_toma"
            data-testid="hora-toma-input"
            type="time"
            value={formData.hora_toma || currentTime}
            onChange={(e) => handleChange('hora_toma', e.target.value)}
            className={`h-11 ${errors.hora_toma ? 'border-red-500' : ''}`}
          />
          {errors.hora_toma && (
            <p className="text-sm text-red-500">{errors.hora_toma}</p>
          )}
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="prueba_solicitada" className="font-medium text-slate-700">
          Prueba solicitada <span className="text-red-500">*</span>
        </Label>
        <Textarea
          id="prueba_solicitada"
          data-testid="prueba-solicitada-textarea"
          placeholder="Hemograma completo, Bioquímica sanguínea, Urocultivo..."
          value={formData.prueba_solicitada}
          onChange={(e) => handleChange('prueba_solicitada', e.target.value)}
          rows={4}
          className={errors.prueba_solicitada ? 'border-red-500' : ''}
        />
        {errors.prueba_solicitada && (
          <p className="text-sm text-red-500">{errors.prueba_solicitada}</p>
        )}
        <p className="text-xs text-slate-500">
          Liste todas las pruebas que desea solicitar
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="observaciones" className="font-medium text-slate-700">
          Observaciones
        </Label>
        <Textarea
          id="observaciones"
          data-testid="observaciones-textarea"
          placeholder="Diagnóstico presuntivo, historia clínica, tratamiento antes de la toma de muestra, etc."
          value={formData.observaciones}
          onChange={(e) => handleChange('observaciones', e.target.value)}
          rows={5}
        />
        <p className="text-xs text-slate-500">
          Incluya cualquier información relevante para el laboratorio
        </p>
      </div>
    </div>
  );
}